import { createIcon } from '@chakra-ui/icons';

// hugeicons "calendar-03" — the Workshop Dates stat tile (Workshops Figma 1943:15531).
export const Calendar03 = createIcon({
  displayName: 'Calendar03',
  viewBox: '0 0 24 24',
  path: (
    <g transform="translate(2 1)">
      <path fill="none" d="M14 1V5M6 1V5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path fill="none" d="M11 3H9C5.22877 3 3.34315 3 2.17157 4.17157C1 5.34315 1 7.22876 1 11V13C1 16.7712 1 18.6569 2.17157 19.8284C3.34315 21 5.22877 21 9 21H11C14.7712 21 16.6569 21 17.8284 19.8284C19 18.6569 19 16.7712 19 13V11C19 7.22876 19 5.34315 17.8284 4.17157C16.6569 3 14.7712 3 11 3Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path fill="none" d="M1 9H19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path fill="none" d="M9.99552 13H10.0045M9.99552 17H10.0045M13.991 13H14M6 13H6.00897M6 17H6.00897" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </g>
  ),
});
